import { useTranslation } from "react-i18next";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

import { formatMoney } from "../../helpers/formatters";
import SkeletonItems from "./SkeletonItems";

import "./style.scss";
import { useLocation } from "react-router-dom";

const Invoice = () => {
  const { state } = useLocation();
  const [bookingDetails, setBookingDetails] = useState(null);
  const [customerDetails, setCustomerDetails] = useState({});
  const [productDetails, setProductDetails] = useState({});
  const [error, setError] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const { t } = useTranslation();

  const handleClose = () => {
    setShowPrivacy(false);
  };

  useEffect(() => {
    if (state) {
      setBookingDetails(state?.session);
      setCustomerDetails(JSON.parse(state?.session?.customer_details));
      setProductDetails(JSON.parse(state?.session?.product_details));
    } else {
      setError(true);
    }
  }, [state]);

  return (
    <>
      <div className="container Invoice__wrapper">
        <a
          href="https://okayama-kanko.jp"
          className="btn btn-secondary fw-bold mb-4"
        >
          {t("back_to_booking")}
        </a>
        {!error ? (
          bookingDetails ? (
            <div className="wrapper">
              <div className="header">{t("booking_req_detail_wait")}</div>
              <div className="body">
                <div className="mb-3"> {t("booking_req_instructions")}</div>
                <div className="grey p-3">
                  <div className="row">
                    <div className="col-3">
                      <b>{t("booking_date")}</b>
                    </div>
                    <div className="col-9 border-start">
                      {moment(bookingDetails.requested_at).format("LLL")}
                    </div>
                  </div>
                  <div className="row border-top">
                    <div className="col-3">
                      <b>{t("booking_reference")}</b>
                    </div>
                    <div className="col-9 border-start">
                      {bookingDetails.status}
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col-6">
                      <div className="border-bottom">
                        <b>{t("booked_by")}:</b>
                      </div>
                      <div className="d-flex flex-column">
                        <span>
                          <b>{t("name")}:</b>&nbsp;
                          {customerDetails.firstName +
                            " " +
                            customerDetails.lastName}
                        </span>
                        <span>
                          <b>{t("address")}:</b>&nbsp;
                          {customerDetails.address}
                        </span>
                        <span>
                          <b>{t("phone")}:</b>&nbsp;
                          {customerDetails.phone}
                        </span>
                        <span>
                          <b>{t("mobile")}:</b>&nbsp;
                          {customerDetails.mobile}
                        </span>
                        <span>
                          <b>{t("email")}:</b>&nbsp;
                          {customerDetails.email}
                        </span>
                      </div>
                    </div>
                    <div className="col-6 border-start">
                      <div className="border-bottom">
                        <b>{t("supplier_information")}:</b>
                      </div>
                      <div className="d-flex flex-column">
                        <span>
                          <b>{t("name")}:</b>&nbsp;
                          {productDetails.SupplierName}
                        </span>
                        <span>
                          <b>{t("address")}:</b>&nbsp;
                          {productDetails.SupplierAddress}
                        </span>
                        <span>
                          <b>{t("phone")}:</b>&nbsp;
                          {productDetails.SupplierPhone}
                        </span>
                        <span>
                          <b>{t("website")}:</b>&nbsp;
                          {productDetails.SupplierWebsite}
                        </span>
                        <span>
                          <b>{t("email")}:</b>&nbsp;
                          {productDetails.SupplierEmail}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col-12 fw-bold">{t("request_to_book")}</div>
                  </div>
                  <div className="row align-items-start">
                    <div className="col-3">
                      <div className="border-bottom border-top">
                        <b>{t("product")}</b>
                      </div>
                      <div className="d-flex flex-column">
                        {productDetails.ProductName}
                      </div>
                    </div>
                    <div className="col-3 border-start">
                      <div className="border-bottom border-top">
                        <b>{t("options")}</b>
                      </div>
                      <div className="d-flex flex-column">
                        {productDetails.Adults}
                        &nbsp;
                        {t("adult")}
                      </div>
                    </div>
                    <div className="col-3 border-start border-end">
                      <div className="border-bottom border-top">
                        <b>{t("date")}</b>
                      </div>
                      <div className="d-flex flex-column">
                        <div className="mb-3">
                          <h6 className="mb-0">
                            <b>{t("check_in")}</b>
                          </h6>
                          <p className="mb-0">
                            {moment(productDetails.CommencementDate).format(
                              "LLL"
                            )}
                          </p>
                        </div>
                        <div className="mb-3">
                          <h6 className="mb-0">
                            <b>{t("check_out")}</b>
                          </h6>
                          <p className="mb-0">
                            {moment(productDetails.ConcludeDate).format("LLL")}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="border-bottom border-top">
                        <b>Totals</b>
                      </div>
                      <div className="d-flex flex-column">
                        <h6 className="text-end">
                          {productDetails.CurrentCurrency}
                          {productDetails.Price &&
                            formatMoney(productDetails.Price)}
                        </h6>
                      </div>
                    </div>
                    {bookingDetails.product_extras &&
                      JSON.parse(bookingDetails.product_extras).length > 0 &&
                      JSON.parse(bookingDetails.product_extras).map((extra) => {
                        return (
                          <>
                            <div className="col-3 border-top">{extra.Name}</div>
                            <div className="col-3 border-top" />
                            <div className="col-3 border-top" />
                            <div className="col-3 border-top border-left">
                              <h6 className="text-end">
                                {productDetails.CurrentCurrency}
                                {formatMoney(extra.TotalCost)}
                              </h6>
                            </div>
                          </>
                        );
                      })}
                    <div className="col-9 border-end border-top">
                      <h6 className="text-end">{t("total_gst")}</h6>
                    </div>
                    <div className="col-3 border-top">
                      <h6 className="text-end">
                        {bookingDetails.TotalPrice ? (
                          `${productDetails.CurrentCurrency}${formatMoney(
                            bookingDetails.TotalPrice
                          )}`
                        ) : (
                          <p>-</p>
                        )}
                      </h6>
                    </div>
                    {/* <div className="col-9 border-end border-top">
                      <h6 className="text-end">{t("amount_paid")}</h6>
                    </div>
                    <div className="col-3 border-top">
                      <h6 className="text-end">
                        {
                          
                            productDetails.CurrentCurrency
                        }
                      </h6>
                    </div> */}
                    <div className="col-9 border-end border-top border-bottom">
                      <h6 className="text-end">{t("amount_owing")}</h6>
                    </div>
                    <div className="col-3 border-top border-bottom">
                      <h6 className="text-end">
                        {bookingDetails.TotalPrice ? (
                          `${productDetails.CurrentCurrency}${formatMoney(
                            bookingDetails.TotalPrice
                          )}`
                        ) : (
                          <p>-</p>
                        )}
                      </h6>
                    </div>
                  </div>
                  <b>{t("special_requests")}</b>
                  <br />
                  <p className="mb-0">
                    {customerDetails.specialRequest ? (
                      customerDetails.specialRequest
                    ) : (
                      <span>-</span>
                    )}
                  </p>
                </div>

                <div className="p-3">
                  <div className="border-bottom mt-3">
                    <h6 className="font-weight-bold">Conditions of Use</h6>
                    <p>condition</p>
                  </div>
                  <div className="border-bottom mt-3">
                    <h6 className="font-weight-bold">Booking Terms</h6>
                    <p>condition</p>
                  </div>
                  <div className="border-bottom mt-3">
                    <h6 className="font-weight-bold">TXJ Privacy Policy</h6>
                    <p
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPrivacy(true)}
                    >
                      Click to view more
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <SkeletonItems />
          )
        ) : (
          <h5 className="text-center">{t("not_found_page")}</h5>
        )}
      </div>

      <Modal show={showPrivacy} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>TXJ Privacy Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>Privacy Text</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            {t("close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Invoice;
